import { Table } from "react-bootstrap";
import styles from "../Header.module.scss";

const ModalTable = ({ portfolioToRender }) => {
  return (
    <Table striped bordered hover size="sm" className={styles.modalTable}>
      <thead>
        <tr>
          <th>#</th>
          <th>Symbol</th>
          <th>Name</th>
          <th>Your amount</th>
          <th>Price (for 1)</th>
          <th>Change per 24h</th>
          <th>Remove</th>
        </tr>
      </thead>
      <tbody>{portfolioToRender}</tbody>
    </Table>
  );
};

export default ModalTable;
